export const getFileExtension = (fileName) => fileName.slice(fileName.lastIndexOf('.'));
